import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Button
} from '@mui/material';
import { CreditCard } from '@mui/icons-material';
import { cardsAPI } from '../services/api';

const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) : '—';

export default function Cards() {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await cardsAPI.listCards();
        const data = res?.data ?? res;
        setCards(Array.isArray(data) ? data : []);
      } catch (e) {
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <Container sx={{ py: 3 }}><Typography>Loading…</Typography></Container>;

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>Digital Cards</Typography>
      {cards.length === 0 ? (
        <Card>
          <CardContent>
            <Typography color="textSecondary">No digital cards yet. Add a policy to generate a card.</Typography>
            <Button sx={{ mt: 1 }} onClick={() => navigate('/wallet')}>Go to Wallet</Button>
          </CardContent>
        </Card>
      ) : (
        <Grid container spacing={2}>
          {cards.map((c) => (
            <Grid item xs={12} sm={6} key={c.id}>
              <Card>
                <CardActionArea onClick={() => navigate(`/cards/${c.id}`)}>
                  <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                      <CreditCard color="primary" />
                      <Typography variant="subtitle1" fontWeight="bold">{c.insurer_name}</Typography>
                    </Box>
                    <Typography variant="body2" color="textSecondary">{c.policy_number} · Expires {formatDate(c.end_date)}</Typography>
                    {(c.member_first_name || c.member_last_name) && (
                      <Typography variant="body2">{c.member_first_name} {c.member_last_name}</Typography>
                    )}
                    <Button size="small" sx={{ mt: 1 }} onClick={(e) => { e.stopPropagation(); navigate(`/cards/${c.id}`); }}>View & QR</Button>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Button sx={{ mt: 2 }} onClick={() => navigate('/wallet')}>Back to Wallet</Button>
    </Container>
  );
}
